export const DRAFT_ORDER_DISCOUNT_COUPON_PREFIX = "DRAFT-ORDER";
export const POS_ORDER_DISCOUNT_COUPON_PREFIX = "POS-ORDER-";
export const EDIT_ORDER_DISCOUNT_COUPON_PREFIX = "EDIT-ORDER";
